export interface SchoolsConfig {
  [district: string]: string[];
}

export const schools: SchoolsConfig = {
  "Foster City School District": [
    "Audubon Elementary School",
    "Beach Park Elementary School",
    "Belmont Oaks Academy",
    "Brewer Island Elementary School",
    "Central Elementary School",
    "College Park Elementary School",
    "Episcopal Day School of St. Matthew",
    "Foster City Elementary School",
    "Kids Connection School",
    "Nesbit Elementary School",
    "San Carlos Charter Learning Center",
    "White Oaks Elementary School"
  ]
};

// Grade options
export interface GradeOption {
  value: string;
  label: string;
}

// Grade config
export const grades: GradeOption[] = [
  { value: "TK", label: "Transitional Kindergarten" },
  { value: "K", label: "Kindergarten (K)" },
  { value: "1", label: "1st Grade" },
  { value: "2", label: "2nd Grade" },
  { value: "3", label: "3rd Grade" },
  { value: "4", label: "4th Grade" },
  { value: "5", label: "5th Grade" },
  { value: "6", label: "6th Grade" },
  { value: "7", label: "7th Grade" },
  { value: "8", label: "8th Grade" },
  { value: "9", label: "9th Grade" },
  { value: "10", label: "10th Grade" },
  { value: "11", label: "11th Grade" },
  { value: "12", label: "12th Grade" },
  { value: "Incoming K", label: "Incoming Kindergarten" },
  { value: "Incoming TK", label: "Incoming Transitional Kindergarten" }
];

// Helper function to get all schools as a flat array
export const getAllSchools = () => {
  return Object.values(schools).flat();
};

// Helper function to get schools by district
export const getSchoolsByDistrict = (district: string) => {
  return schools[district] || [];
}; 
